module.exports = __webpack_public_path__ + "static/fonts/Sui-Number-Medium.364fdf2.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Sui-Number-Medium.otf
// module id = 618
// module chunks = 36